import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useRolesRetrieval } from "@planzone/view-models";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { SelectedIcon } from "@common/selectedIcon";
import { Props } from "./types";
import { ArrowIcon } from "./arrowIcon";
import styles from "./styles.scss";

function RoleSelection({ selectedRole, placeholder, select }: Props) {
  const { t } = useTranslation();
  const { roles } = useRolesRetrieval();

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.roleSelection, {
            [styles.opened]: isVisible,
          })}
        >
          <div className={styles.input} onClick={isVisible ? hide : show}>
            {selectedRole ? (
              <p className={styles.selection}>
                {t(`roles.${selectedRole.name}`, selectedRole.name)}
              </p>
            ) : (
              <p className={classNames(styles.selection, styles.placeholder)}>
                {placeholder}
              </p>
            )}
            <div className={styles.iconBox}>
              <ArrowIcon className={styles.icon} />
            </div>
          </div>
          {isVisible && (
            <div className={styles.list}>
              {roles
                .filter(({ name }) => name.slice(0, "pz_".length) === "pz_")
                .map((role) => (
                  <div
                    key={role.uuid}
                    className={styles.role}
                    onClick={() => {
                      select(role);
                      hide();
                    }}
                  >
                    {selectedRole?.name === role.name ? (
                      <div className={styles.selectedRole}>
                        <div className={styles.selectedRoleTitle}>
                          {t(`roles.${role.name}`, role.name)}{" "}
                          <SelectedIcon className={styles.selectedRoleIcon} />
                        </div>
                      </div>
                    ) : (
                      <div>{t(`roles.${role.name}`, role.name)}</div>
                    )}
                    <div className={styles.roleDescription}>
                      {t(`roles.description.${role.name}`, role.name)}
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { RoleSelection };
